//import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
//import "../../Assets/Styles/Footer1.css";

//export default function Footer() {
//    return (
//        <footer className="simple-footer">
//            <div className="footer-content">
//                <span className="copyright">
//                    © 2026 Bhuhit. All rights reserved.
//                </span>

//                <span className="divider-main">|</span>

//                <span className="contact-info">
//                    <FaEnvelope className="footer-icon" />
//                    contact@energy-guru.com

//                    <span className="divider-sub">|</span>

//                    <FaPhoneAlt className="footer-icon" />
//                    (+91) 80550 99111
//                </span>
//            </div>
//        </footer>
//    );
//}

import { FaEnvelope, FaPhoneAlt } from "react-icons/fa";
import "../../Assets/Styles/Footer1.css";

export default function Footer() {
    return (
        <footer className="simple-footer">
            <div className="footer-content">
                <span className="copyright">
                    © 2026 Bhuhit. All rights reserved.
                </span>
                <span className="divider-main">|</span>
                <span className="contact-info">
                    <FaEnvelope className="footer-icon" />
                    contact@energy-guru.com
                    <span className="divider-sub">|</span>
                    <FaPhoneAlt className="footer-icon" />
                    (+91) 80550 99111
                </span>
            </div>
        </footer>
    );
}